export default "{\n    \"languageSelectPlaceholder\": \"Seleccionar idioma preferido\",\n    \"languageSelectLabel\": \"Idioma\"\n}\n"